import React, { useState, useEffect } from 'react';
import logo from '../assets/LogoQuickSerc.png';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Growl } from 'primereact/growl';
import { useHistory } from 'react-router-dom';
import LoginController from '../controllers/login.controller';

const Login: React.FC = () => {
    const history = useHistory();

    const [usuario, setUsuario] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [mostrarMensajes, setMostrarMensajes] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [growl, setGrowl] = useState<Growl>(new Growl({}));

    useEffect(() => {
        const data = localStorage.getItem('data');
        if (data) {
            history.push('/dashboard')
        }
    }, [])

    const login = () => {
        if (!usuario || !password) {
            setMostrarMensajes(true);
        } else {
            setMostrarMensajes(false);
            setLoading(true);
            LoginController.login(usuario, password).then((response) => {
                if (response.data && response.data.success) {
                    const { data } = response;
                    const { suscripcion } = data;
                    const { usuarioEncontrado } = data;
                    if (!suscripcion || suscripcion.estado !== 'ACTIVA') {
                        growl.show({ severity: 'error', summary: 'Error', detail: 'El establecimiento y/o sucursal no cuentan con una suscripción activa; por favor comuníquese con soporte' });
                    } else if (usuarioEncontrado.perfil.llave !== 'ADM') {
                        growl.show({ severity: 'error', summary: 'Error', detail: 'Su perfil de usuario no le permite ingreso a este módulo' });
                    } else if (!usuarioEncontrado.activo) {
                        growl.show({ severity: 'error', summary: 'Error', detail: 'Usuario inactivo' });
                    } else {
                        localStorage.setItem('data', JSON.stringify(data));
                        history.push('/dashboard')
                    }
                } else {
                    growl.show({ severity: 'error', summary: 'Error', detail: 'Usuario o contraseña incorrectos' });
                }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    return <>
        <div className='login-screen'>
            <Growl ref={(el: Growl) => setGrowl(el)} />
            <div className='right-column'>
                <div className='right-column-title'>
                    INGRESO AL SISTEMA
                </div>
                <img src={logo} alt='Quickserk' className='login-logo' />
            </div>
            <div className='left-column'>
                <div className='login-form'>
                    <Dialog visible={loading} style={{ width: '50vw' }}
                        onHide={() => setLoading(false)}
                        closable={false}
                        closeOnEscape={false}
                        contentStyle={{ textAlign: 'center' }}>
                        <ProgressSpinner />
                    </Dialog>
                    <span className="p-float-label">
                        <InputText id='itUsuario' value={usuario}
                            onChange={(e: any) => setUsuario(e.target.value)} />
                        <label htmlFor='itUsuario' style={{ color: '#505050' }}>Usuario</label>
                    </span>
                    {
                        mostrarMensajes && !usuario ?
                            <Message severity='error' text='Campo requerido' />
                            : null
                    }
                    <span className="p-float-label span-contrasena">
                        <Password id='pwContrasena' feedback={false} value={password}
                            onChange={(e: any) => setPassword(e.target.value)} />
                        <label htmlFor='pwContrasena' style={{ color: '#505050' }}>Contraseña</label>
                    </span>
                    {
                        mostrarMensajes && !password ?
                            <Message severity='error' text='Campo requerido' />
                            : null
                    }
                    <div style={{ marginTop: 40 }}>
                        <Button className='login-button' label='Ingresar'
                            onClick={login} />
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default Login;